import {RequestInformation} from "./RequestInformation";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {get, post} from "../../js/api";
import {BreadCrumb} from "../../component/Breadcrumb";
import {OrderCorrespondence} from "../../component/OrderCorrespondence";
import {Layout} from "../../component/layout/Layout";
import {Button} from "../../component/form/Button";
import {markDirty, showMessage} from "../../js/main";
import {RefreshSignal, useChangeEffect} from "../../js/util";
import {orderType} from "../../js/constants";

const refresh = new RefreshSignal();

export const UpdateGuestRequest = ({}) => {

    const [order, setOrder] = useState();
    const [reply, setReply] = useState();

    const [submitting, setSubmitting] = useState(false);

    const {token} = useParams();

    useEffect(() => {
        get(`/public/orders/${token}`).then(order => {
            if(order.type == orderType.standard){
                window.location = `/public-order/${token}`;
            }else{
                setOrder(order);
            }
        });
    }, []);

    const updateOrder = () => {
        setSubmitting(true);
        post(`/public/orders/${token}/correspondence`, reply).then(() => {
            showMessage("Die Antwort wurde erfolgreich gespeichert");
            refresh.changed();
        }).finally(() => {
            setSubmitting(false);
        })
    }

    return (
        <>
            {order && <Layout username={null}>
                <BreadCrumb currentTitle="Anfrage: Nachschlüssel"/>
                {order && <>
                    <RequestInformation order={order}/>
                </>
                }

                <form onSubmit={e => {
                    e.preventDefault()
                    updateOrder();
                }}>
                    <OrderCorrespondence adminView={false} identifier={token} isPublic={true} onCreateReply={setReply} refresh={refresh}/>

                    <div className={"safe-actions mt-1"}>
                        <Button type={"submit"} key="submit" theme="blue mb-1" width={230}
                                submitting={submitting}>Antwort absenden</Button>
                    </div>
                </form>
            </Layout>}
        </>
    )
}